import { TranslationKeys } from "./en";

export const pt: TranslationKeys = {
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "add": "Adicionar",
    "delete": "Excluir",
    "close": "Fechar",
    "edit": "Editar",
    "reset": "Limpar",
    "search": "Buscar",
    "loading": "Carregando...",
    "saving": "Salvando...",
    "ready": "Pronto",
    "synced": "Sincronizado",
    "syncError": "Erro de Sincronização",
    "cards": "cartas",
    "sets": "Coleções",
    "shining": "brilhantes",
    "all": "Todos",
    "remove": "Remover",
    "confirm": "Confirmar",
    "success": "Sucesso",
    "error": "Erro",
    "optional": "Opcional"
  },
  "nav": {
    "pokedex": "Pokédex",
    "nationalDex": "Pokémons",
    "decks": "Decks",
    "rules": "Regras",
    "profile": "Ajustes",
    "signIn": "Entrar",
    "signOut": "Sair",
    "whitelisted": "Autorizado",
    "trainer": "Treinador",
    "guestVisitor": "Visitante Convidado",
    "opticalSensor": "Sensor Óptico da Pokédex",
    "enableSounds": "Ativar sons",
    "muteSounds": "Desativar sons",
    "version": "v1.0"
  },
  "preferences": {
    "title": "Preferências do Usuário",
    "subtitle": "Personalize o idioma da interface, efeitos sonoros e sua experiência no aplicativo",
    "languageLabel": "Idioma / Language",
    "languagePt": "Português (BR)",
    "languageEn": "English",
    "languageSavedNotice": "Sua preferência de idioma fica gravada no seu navegador e é restaurada automaticamente ao retornar.",
    "soundLabel": "Efeitos Sonoros",
    "soundEnabled": "Sons Ativados",
    "soundEnabledDesc": "Efeitos sonoros estilo Pokédex em cliques e ações",
    "soundMuted": "Silencioso / Mutado",
    "soundMutedDesc": "Todos os efeitos sonoros desligados",
    "soundSavedNotice": "Sua preferência de áudio fica gravada no seu navegador e é restaurada automaticamente ao retornar."
  },
  "pokedex": {
    "title": "Banco de Cartas & Pokédex",
    "subtitle": "{count} cartas encontradas na coleção ativa",
    "addCardsBtn": "Adicionar Cartas / Importar CSV",
    "totalOwned": "Total Obtido",
    "uniqueRegistered": "Únicas Registradas",
    "foilHolo": "Foil / Holográficas",
    "completion": "Conclusão",
    "noCardsFound": "Nenhuma Carta Encontrada",
    "noCardsFoundDesc": "Tente ajustar seus filtros ou termos de pesquisa."
  },
  "filters": {
    "searchPlaceholder": "Buscar por nome (Charizard, Darkrai), nº (#88), sigla...",
    "clearSearch": "Limpar busca",
    "allCategories": "Todas as Categorias",
    "pokemonOnly": "Apenas Pokémon",
    "trainersOnly": "Apenas Treinadores",
    "energiesOnly": "Apenas Energias",
    "allSets": "Todas as Coleções",
    "sortBy": "Ordenar por",
    "sortCardNum": "Nº da Carta",
    "sortName": "Nome (A-Z)",
    "sortQuantity": "Quantidade",
    "sortRarity": "Raridade",
    "resetFilters": "Limpar",
    "foilOnly": "Apenas Foil / Holo",
    "mappedInDecks": "Presentes em Decks",
    "ownedOnly": "Obtidas (Qtd > 0)",
    "duplicatesOnly": "Repetidas (>1)",
    "missingOnly": "Faltando (Qtd = 0)",
    "types": {
      "ALL": "Todos os Tipos",
      "grass": "Planta",
      "fire": "Fogo",
      "water": "Água",
      "lightning": "Raios",
      "psychic": "Psíquico",
      "fighting": "Luta",
      "darkness": "Escuridão",
      "metal": "Metal",
      "fairy": "Fada",
      "dragon": "Dragão",
      "colorless": "Incolor",
      "trainer": "Treinador",
      "energy": "Energia"
    }
  },
  "cardItem": {
    "removeFavorite": "Remover dos favoritos",
    "addFavorite": "Adicionar aos favoritos",
    "deckPrefix": "D"
  },
  "cardDetail": {
    "titlePrefix": "Dados da Pokédex //",
    "favorite": "Favorita",
    "addToFavs": "Favoritar",
    "qty": "Qtd:",
    "removeCard": "Remover esta carta da coleção",
    "confirmDelete": "Remover \"{name}\" da coleção?",
    "expansionSet": "Coleção:",
    "setCode": "Sigla da Coleção:",
    "cardNumber": "Número da Carta:",
    "rarity": "Raridade:",
    "condition": "Estado de Conservação:",
    "language": "Idioma:",
    "addToDeck": "Adicionar ao Deck:",
    "added": "Adicionado!",
    "addBtn": "Adicionar",
    "featuredInDecks": "Incluído nos Decks:",
    "personalNotes": "Anotações Pessoais:",
    "saved": "Salvo!",
    "notesPlaceholder": "Ex: Combo de turno 1 com Mewtwo & Mew-GX, guardar para late-game...",
    "saveCardNote": "Salvar Anotação da Carta",
    "foilHolo": "Foil / Holográfica",
    "priceSectionTitle": "Valor de Mercado & Coleção",
    "priceLabel": "Valor da Carta (R$)",
    "pricePlaceholder": "Ex: 25,00 ou 150.50",
    "priceUpdatedLabel": "Data da Atualização",
    "savePrice": "Salvar Valor",
    "priceSaved": "Valor salvo!",
    "deckCardToggle": "Carta Escolhida para o Deck deste Pokémon",
    "deckCardActive": "Esta é a carta escolhida deste Pokémon para o deck",
    "deckCardInactive": "Não selecionada para o deck"
  },
  "decks": {
    "title": "Construtor Tático de Decks",
    "subtitle": "Gerencie seus decks de 60 cartas, playbooks estratégicos e distribuição de energia",
    "cardsCount": "Deck de {count} Cartas",
    "exportLive": "Exportar (PTCG Live)",
    "decklistCopied": "Lista de Cartas Copiada!",
    "editDeckBtn": "Editar Deck & Playbook",
    "deleteDeck": "Excluir Deck",
    "confirmDelete": "Tem certeza que deseja excluir o deck \"{name}\"?",
    "createDeck": "Criar Novo Deck",
    "validateDeck": "Validar Deck (CSV)",
    "composition": "Composição ({count} Cartas)",
    "pokemonCount": "{count} Pokémon",
    "trainersCount": "{count} Treinadores",
    "energiesCount": "{count} Energias",
    "energyBreakdown": "Distribuição de Energia",
    "energyRequired": "Necessário: {needed}",
    "energyComplete": "Energias completas!",
    "winCondition": "Condição de Vitória",
    "playbook": "Playbook Estratégico de Turnos",
    "opening": "1. Abertura",
    "midgame": "2. Meio de Jogo",
    "endgame": "3. Fim de Jogo",
    "customizePlaybook": "Personalizar Playbook",
    "prizeTradeTip": "Dica de Troca de Prêmios:",
    "completeList": "Lista Completa de Cartas do Deck",
    "pokemonSection": "Pokémon ({count})",
    "trainersSection": "Treinadores ({count})",
    "energySection": "Energias ({count})",
    "owned": "Na Coleção: {count}",
    "missing": "Faltando",
    "removeFromDeck": "Remover do deck"
  },
  "editDeck": {
    "title": "Editar Deck & Playbook Estratégico",
    "tabPlaybook": "Playbook de Turnos Estratégicos",
    "tabDetails": "Detalhes do Deck & Tema",
    "winConditionLabel": "Condição de Vitória & Objetivo Principal",
    "winConditionPlaceholder": "Ex: Coletar 6 Cartas de Prêmio ciclando Energia com Malamar para energizar o ataque Laser Especial do Necrozma.",
    "prizeTradeLabel": "Dica de Troca de Prêmios (Prize Trade)",
    "prizeTradePlaceholder": "Ex: Procure trocar atacantes de 1 Prêmio eficientemente contra Pokémon-GX/V de 2 Prêmios do adversário.",
    "openingPlan": "1. Plano de Abertura / Early Game",
    "midgamePlan": "2. Estratégia de Meio de Jogo / Midgame",
    "endgamePlan": "3. Finalização / Fim de Jogo",
    "defaultOpeningTitle": "1. Plano de Abertura (Turnos 1 e 2)",
    "defaultMidgameTitle": "2. Meio de Jogo (Turnos 3 a 5)",
    "defaultEndgameTitle": "3. Finalização de Partida",
    "addStep": "Adicionar Passo",
    "sectionTitlePlaceholder": "Título da seção (ex: 1. Plano de Abertura)...",
    "stepPlaceholder": "Instruções do passo {num}...",
    "deckName": "Nome do Deck *",
    "namePlaceholder": "Ex: Necrozma (Laser Focus)",
    "archetype": "Arquétipo",
    "archetypePlaceholder": "Ex: Caixa de Ferramentas Psíquica / Malamar Turbo",
    "format": "Formato",
    "formatStandard": "Padrão (Standard)",
    "formatExpanded": "Expandido (Expanded)",
    "formatCasual": "Casual",
    "accentColor": "Cor de Destaque & Brilho",
    "summary": "Resumo da Estratégia",
    "summaryPlaceholder": "Visão geral da estratégia de funcionamento deste deck...",
    "saveChanges": "Salvar Alterações"
  },
  "createDeck": {
    "title": "Criar Novo Deck (Deck Builder)",
    "deckName": "Nome do Deck *",
    "namePlaceholder": "Ex: Gardevoir Psychic Turbo",
    "format": "Formato",
    "formatStandard": "Padrão (Standard)",
    "formatExpanded": "Expandido (Expanded)",
    "formatCasual": "Casual",
    "archetype": "Arquétipo",
    "archetypePlaceholder": "Ex: Aggro, Controle, OHKO, Toolbox",
    "winCondition": "Condição de Vitória",
    "winConditionPlaceholder": "Ex: Alto dano explosivo no Turno 2 com aceleração de energia",
    "cardsCount": "{current} / 60 Cartas",
    "pokemonCount": "{count} Pokémon",
    "trainersCount": "{count} Treinadores",
    "energiesCount": "{count} Energias",
    "fullDeck": "Deck Completo!",
    "cardsLeft": "{count} restantes",
    "excessCards": "{count} excedentes",
    "addCardsCollection": "Adicionar Cartas da Coleção:",
    "searchCardsPlaceholder": "Buscar na coleção por nome ou tipo...",
    "add": "Adicionar",
    "cardsInDeck": "Cartas no Deck ({count} tipos):",
    "saveDeck": "Salvar Deck"
  },
  "addCard": {
    "title": "Adicionar Cartas à Coleção",
    "tabManual": "Formulário Manual",
    "tabCsv": "Importação em Lote via CSV",
    "tabValidate": "Validar Deck (CSV)",
    "quickSearchLabel": "⚡ Busca Inteligente (Nome + Nº / Tiragem)",
    "quickSearchPlaceholder": "Ex: Charizard 10/78, Mewtwo 81/182, Ultra Bola 196...",
    "quickSearchBtn": "Autopreencher",
    "quickSearchSearching": "Buscando dados da carta...",
    "quickSearchSuccess": "Carta \"{name}\" ({set} #{num}) preenchida com sucesso!",
    "quickSearchNotFound": "Nenhuma carta encontrada para \"{query}\". Verifique a grafia ou preencha manualmente.",
    "quickSearchSelectPrompt": "Edições encontradas ({count}). Clique em uma para preencher:",
    "nameEn": "Nome da Carta (Inglês) *",
    "nameEnPlaceholder": "Ex: Charizard ex",
    "namePt": "Nome da Carta (Português / Sinônimo)",
    "namePtPlaceholder": "Ex: Charizard ex",
    "setCode": "Sigla Coleção *",
    "setCodePlaceholder": "Ex: SVI, PAF, OBF",
    "cardNumber": "Nº da Carta *",
    "cardNumberPlaceholder": "Ex: 054 ou 125",
    "totalInSet": "Total na Coleção",
    "totalInSetPlaceholder": "Ex: 198",
    "typeCategory": "Tipo / Categoria",
    "rarity": "Raridade",
    "rarityCommon": "Comum (C)",
    "rarityUncommon": "Incomum (U)",
    "rarityRare": "Rara (R)",
    "rarityRareHolo": "Rara Holo (RH)",
    "rarityUltraRare": "Ultra Rara (RU/GX)",
    "rarityDoubleRare": "Dupla Rara (RD/ex)",
    "rarityIllustrationRare": "Ilustração Rara (IR)",
    "raritySecretRare": "Secreta Rara (S)",
    "quantity": "Quantidade",
    "imageSectionTitle": "Imagem da Carta & Upload para o Cloud Storage",
    "imageOptionA": "Opção A: Enviar Arquivo de Imagem",
    "imageOptionB": "Opção B: URL Externa da Imagem",
    "imageReadyNotice": "Imagem pronta para upload no Cloud Storage ao salvar",
    "isFoil": "Carta Holográfica (Foil / Holo)",
    "uploadingAndSaving": "Enviando Imagem para o Storage & Salvando...",
    "saveCardBtn": "Salvar Carta na Coleção & Storage",
    "csvHelp": "Cole o texto da planilha ou CSV (formato Pokémon TCG / LigaPokémon) ou envie um arquivo .csv:",
    "deckAssignment": "Atribuição de Deck:",
    "deckModeNone": "Apenas Coleção",
    "deckModeExisting": "Deck Existente",
    "deckModeNew": "+ Novo Deck",
    "selectExistingDeck": "Selecionar Deck Existente:",
    "newDeckName": "Nome do Novo Deck *",
    "newDeckNamePlaceholder": "Ex: Malamar Necrozma Turbo",
    "format": "Formato",
    "importSuccess": "Importação concluída: {added} adicionadas, {updated} atualizadas",
    "importAndCreateDeck": "Importar & Criar Deck \"{name}\"",
    "importAndAddToDeck": "Importar & Adicionar ao Deck Existente",
    "processCsv": "Processar Importação CSV",
    "cardAddedSuccessTitle": "Carta Adicionada com Sucesso!",
    "cardAddedSuccessDesc": "A carta foi registrada no seu catálogo e sincronizada com a sua Pokédex.",
    "cardUpdatedSuccessTitle": "Carta Repetida - Quantidade Atualizada!",
    "cardUpdatedSuccessDesc": "Esta carta já constava na sua coleção. O número de cópias foi atualizado para x{count} sem criar uma carta duplicada.",
    "addAnotherCard": "+ Adicionar Outra Carta",
    "finishBtn": "Concluir e Fechar"
  },
  "validator": {
    "title": "Validador de Deck (CSV vs Coleção)",
    "subtitle": "Verifique quais cartas e quantidades você possui e o que falta para montar este deck sem alterar sua coleção",
    "uploadHelp": "Envie um arquivo CSV de deck ou cole os dados no formato LigaPokémon / Pokémon TCG:",
    "validateBtn": "Validar Deck com Minha Coleção",
    "validating": "Analisando Cartas...",
    "newValidation": "Nova Validação",
    "deckHealth": "Status de Disponibilidade do Deck",
    "deckComplete": "Deck 100% Pronto para Montar!",
    "deckCompleteDesc": "Sua coleção possui todas as {total} cartas necessárias para este deck.",
    "deckIncomplete": "Faltam Cartas para Montar o Deck",
    "deckIncompleteDesc": "Você tem {owned} de {total} cartas ({percent}%). Faltam {missing} carta(s) para completar.",
    "totalInDeck": "Total no Deck",
    "inCollection": "Na Coleção",
    "missingCount": "Faltando",
    "readiness": "Prontidão",
    "filterAll": "Todas ({count})",
    "filterMissing": "Apenas Faltando ({count})",
    "filterComplete": "Completas ({count})",
    "needed": "Necessário",
    "owned": "Possui",
    "missing": "Falta {count}",
    "complete": "Completo ({owned}/{needed})",
    "surplus": "Sobrando (+{count})",
    "inOtherEditions": "{count} em outras coleções",
    "copyMissingList": "Copiar Lista de Faltantes",
    "copied": "Lista Copiada!",
    "noMissing": "Excelente! Você tem absolutamente todas as cartas necessárias para montar este deck.",
    "noCardsParsed": "Nenhuma carta válida pôde ser lida do CSV. Verifique o formato.",
    "similarCardsTitle": "Cartas Similares / Substitutas na Coleção ({count})",
    "useAsSubstitute": "Usar como Substituta",
    "substituteAssigned": "Substituída por {name}",
    "removeSubstitute": "Remover Substituição",
    "searchSubstitutePlaceholder": "Buscar outra carta na coleção para substituir...",
    "noSimilarFound": "Nenhuma carta similar encontrada automaticamente.",
    "readinessWithSubstitutes": "Prontidão com substitutas: {percent}% ({count}/{total})",
    "substitutesCount": "{count} substituta(s) atribuída(s)"
  },
  "profile": {
    "title": "Perfil de Treinador & Sincronização em Nuvem",
    "cloudSync": "Sincronização em Tempo Real no Cloud Firestore",
    "cloudSyncDesc": "Salvamento automático contínuo de cartas, quantidades, decks personalizados e anotações",
    "totalOwned": "Total Obtido",
    "customDecks": "Decks Customizados",
    "favorites": "Favoritas",
    "lastCloudSync": "Última Sincronização",
    "syncExplanation": "Cada alteração realizada (ajuste de quantidades, montagem de decks, favoritas) é automaticamente persistida em tempo real na sua coleção privada do Cloud Firestore.",
    "forceSync": "Forçar Sincronização Agora",
    "syncing": "Sincronizando...",
    "whitelistWarning": "Seu e-mail não está cadastrado em VITE_ALLOWED_EMAILS. Adicione-o ao arquivo .env para habilitar a sincronização em tempo real.",
    "whitelistedEmails": "E-mails Autorizados na Lista (VITE_ALLOWED_EMAILS)",
    "whitelistDesc": "Apenas usuários autenticados cujos e-mails estejam nesta lista possuem autorização para sincronizar e gravar alterações no banco em nuvem.",
    "noEmailsConfigured": "Nenhum e-mail configurado (modo aberto de desenvolvimento).",
    "storagePipeline": "Pipeline de Imagens do Firebase Storage",
    "storagePipelineDesc": "As cartas resolvem automaticamente imagens em alta resolução dos CDNs oficiais ou do seu bucket privado do Firebase Storage configurado no .env.",
    "setsSyncTitle": "Sincronização de Coleções (TCG Sets Sync)",
    "setsSyncDesc": "Atualiza metadados oficiais de coleções (anos, códigos e marcas de regulamentação) via API TCGdex e Cloud Firestore",
    "setsCataloged": "Coleções Catalogadas",
    "lastSetsSync": "Última Sincronização de Sets",
    "syncSetsBtn": "Sincronizar Coleções Agora",
    "syncingSets": "Buscando Coleções na API...",
    "setsSyncSuccess": "{total} coleções sincronizadas com sucesso!",
    "setsSyncExplanation": "Consulta a API oficial com todas as coleções do Pokémon TCG, calcula automaticamente os anos e as letras de rotação competitiva (D, E, F, G, H, I, J...) e grava as configurações no Firebase.",
    "shareTitle": "Compartilhamento da Coleção (Link Somente Leitura)",
    "shareDesc": "Dê acesso seguro às suas cartas e decks para outro usuário via link secreto sem usar sua conta",
    "shareActiveBadge": "Link Ativo",
    "shareInactiveBadge": "Desativado",
    "shareLinkLabel": "Link Secreto de Visualização (Somente Leitura)",
    "shareGenerateBtn": "Gerar Link de Compartilhamento",
    "generateLinkBtn": "Gerar Link de Compartilhamento",
    "generatingLink": "Gerando Link...",
    "shareRotateBtn": "Gerar Novo Link",
    "rotateLinkBtn": "Gerar Novo Link",
    "shareRevokeBtn": "Revogar Acesso",
    "revokeLinkBtn": "Revogar Acesso",
    "revokingLink": "Revogando Acesso...",
    "shareCopyBtn": "Copiar Link",
    "copyLinkBtn": "Copiar Link",
    "shareCopiedBtn": "Link Copiado!",
    "linkCopied": "Link Copiado!",
    "shareRotatedNotice": "Novo link secreto gerado! O link anterior foi invalidado imediatamente.",
    "shareRevokedNotice": "Acesso compartilhado revogado! O link foi desativado.",
    "shareExplanation": "Qualquer pessoa com este link secreto poderá visualizar suas cartas e decks em Modo Somente Leitura (sem precisar fazer login). Ela não poderá adicionar, editar ou excluir nada. Ao gerar um novo link ou revogar o acesso, o link anterior deixa de funcionar imediatamente.",
    "shareConfirmRevoke": "Deseja revogar o link atual? Qualquer pessoa usando este link perderá o acesso imediatamente.",
    "shareConfirmRotate": "Deseja gerar um novo link? O link antigo deixará de funcionar imediatamente.",
    "visitorBadge": "Modo Visitante (Somente Leitura)",
    "visitorModeTitle": "Modo Visitante (Somente Leitura)",
    "visitorModeDesc": "Você está visualizando a coleção compartilhada de {owner}. Edições estão desativadas para proteger as cartas do proprietário.",
    "visitorBannerText": "Modo Somente Leitura • Coleção de {owner}",
    "exitVisitorBtn": "Sair do Modo Visitante",
    "versionTitle": "Versão do Sistema & Atualizações PWA",
    "versionSubtitle": "Controle de versão compilada, limpeza profunda de cache e atualização de PWA",
    "installedVersion": "Versão Instalada",
    "buildNumber": "Build",
    "buildTime": "Data de Compilação",
    "statusUpToDate": "Aplicação Atualizada",
    "statusUpdateAvailable": "Nova Versão Disponível",
    "checkUpdatesBtn": "Verificar Atualização",
    "checkingUpdates": "Verificando...",
    "forceUpdateBtn": "Forçar Atualização & Limpar Cache PWA",
    "pwaHelp": "Se você instalou o app no celular como PWA e as telas não estiverem atualizando, clique em 'Forçar Atualização'. Isso desregistra os service workers, limpa o CacheStorage e baixa a versão mais recente dos servidores.",
    "updateBannerText": "Nova versão {version} disponível!",
    "updateBannerBtn": "Atualizar Agora"
  },
  "accessGate": {
    "booting": "Iniciando Pokédex OS...",
    "verifying": "Verificando credenciais de treinador",
    "accessDenied": "Acesso Negado",
    "unauthorizedAccount": "Conta Não Autorizada",
    "accountNotAuthorized": "Conta Não Autorizada",
    "notAuthorizedDesc": "Você está conectado como {email}, mas este endereço de e-mail não está autorizado a acessar esta Pokédex.",
    "signedInAs": "Você está conectado como {email}, mas este endereço de e-mail não está autorizado a acessar esta Pokédex.",
    "signInAnother": "Entrar com Outra Conta",
    "signInTitle": "Identificação de Treinador",
    "welcomeDesc": "Faça login com sua conta Google autorizada para acessar sua coleção e decks de Pokémon.",
    "signInGoogle": "Entrar com o Google (Gmail)",
    "authError": "Erro de Autenticação",
    "invalidShareTitle": "Link Inválido ou Revogado",
    "invalidShareDesc": "Este link de coleção compartilhada não está mais ativo ou foi revogado pelo treinador.",
    "goToLoginBtn": "Ir para o Login",
    "versionTitle": "Versão do Sistema & Atualizações PWA",
    "versiontitle": "Versão do Sistema & Atualizações PWA",
    "versionSubtitle": "Controle de versão compilada, limpeza profunda de cache e atualização de PWA",
    "versionsubtitle": "Controle de versão compilada, limpeza profunda de cache e atualização de PWA",
    "installedVersion": "Versão Instalada",
    "installedversion": "Versão Instalada",
    "buildNumber": "Build",
    "buildnumber": "Build",
    "buildTime": "Data de Compilação",
    "buildtime": "Data de Compilação",
    "statusUpToDate": "Aplicação Atualizada",
    "statusuptodate": "Aplicação Atualizada",
    "statusUpdateAvailable": "Nova Versão Disponível",
    "statusupdateavailable": "Nova Versão Disponível",
    "checkUpdatesBtn": "Verificar Atualização",
    "checkupdatesbtn": "Verificar Atualização",
    "checkingUpdates": "Verificando...",
    "checkingupdates": "Verificando...",
    "forceUpdateBtn": "Forçar Atualização & Limpar Cache PWA",
    "forceupdatebtn": "Forçar Atualização & Limpar Cache PWA",
    "pwaHelp": "Se você instalou o app no celular como PWA e as telas não estiverem atualizando, clique em 'Forçar Atualização'. Isso desregistra os service workers, limpa o CacheStorage e baixa a versão mais recente dos servidores.",
    "pwahelp": "Se você instalou o app no celular como PWA e as telas não estiverem atualizando, clique em 'Forçar Atualização'. Isso desregistra os service workers, limpa o CacheStorage e baixa a versão mais recente dos servidores.",
    "updateBannerText": "Nova versão {version} disponível!",
    "updatebannertext": "Nova versão {version} disponível!",
    "updateBannerBtn": "Atualizar Agora",
    "updatebannerbtn": "Atualizar Agora"
  },
  "rules": {
    "title": "Regras, Tipos & Formatos de Batalha",
    "subtitle": "Guia completo de tipos elementais do Pokémon TCG, formatos competitivos, cartas de treinador e condições especiais",
    "tabTypes": "11 Tipos Elementais",
    "tabFormats": "Formatos & Regras",
    "tabTrainers": "Cartas de Treinador",
    "tabConditions": "Condições Especiais",
    "tabSets": "Coleções do TCG",
    "setsTitle": "Coleções & Expansões Oficiais do Pokémon TCG",
    "setsSubtitle": "Consulte anos de lançamento, marcas de regulamentação (letras) e status competitivo de cada expansão",
    "searchSetsPlaceholder": "Buscar por nome (Escuridão Absoluta, Astros), código (ME05, SSP) ou ano...",
    "allEras": "Todas as Eras / Marcas",
    "markFilter": "Marca {mark} ({year})",
    "classicFilter": "Clássico / Sem Marca (1999-2019)",
    "officialCode": "Sigla",
    "regulationMark": "Marca de Regulamentação",
    "releaseYear": "Ano de Lançamento",
    "totalCardsInSet": "{count} cartas",
    "formatStandard": "Formato Padrão (Standard)",
    "formatExpanded": "Formato Expandido",
    "formatVintage": "Clássico / Vintage",
    "noSetsFound": "Nenhuma coleção encontrada com estes filtros",
    "syncSetsListBtn": "Sincronizar Coleções da API",
    "strengthsTitle": "Vantagens Elementais & Confrontos de Tipos",
    "weakness": "Fraqueza",
    "resistance": "Resistência",
    "superEffective": "Super Efetivo Contra (Vantagem de Ataque)",
    "deckSize": "Tamanho do Deck",
    "cardLimit": "Limite de Cópias",
    "sampleCard": "Carta Exemplo em Destaque",
    "examples": "Exemplos",
    "statusEffect": "Efeito de Status",
    "effect": "Efeito",
    "howToCure": "Como Curar",
    "archetypeStrengths": "Pontos Fortes do Arquétipo & Mecânicas Marcantes",
    "iconicCards": "Cartas Icônicas e Representativas",
    "coreRules": "Regras Fundamentais para Construção de Decks",
    "competitiveFormats": "Formatos Competitivos & Casuais",
    "prizeCards": "Cartas de Prêmio",
    "clearFilters": "Limpar filtros",
    "classicBadge": "Clássico",
    "markOptionJ": "Marca [J] (2025/2026 - Standard)",
    "markOptionI": "Marca [I] (2025 - Standard)",
    "markOptionH": "Marca [H] (2024 - Standard)",
    "markOptionG": "Marca [G] (2023 - Standard)",
    "markOptionF": "Marca [F] (2022 - Expandido)",
    "markOptionE": "Marca [E] (2021 - Expandido)",
    "markOptionD": "Marca [D] (2020 - Expandido)",
    "tabRarities": "Raridades das Cartas",
    "raritiesTitle": "Guia Oficial de Raridades & Taxas de Booster",
    "raritiesSubtitle": "Identifique símbolos, nomes oficiais, frequências de abertura por booster e coleções de referência",
    "rarityPullRate": "Taxa por Booster",
    "raritySymbol": "Símbolo",
    "rarityReference": "Coleção de Referência",
    "searchRaritiesPlaceholder": "Buscar por nome, símbolo ou taxa...",
    "syncRaritiesBtn": "Sincronizar Raridades",
    "syncingRarities": "Sincronizando Raridades...",
    "noRaritiesFound": "Nenhuma raridade encontrada com este filtro"
  },
  "pagination": {
    "pageInfo": "Página {current} de {total}",
    "prev": "Página Anterior",
    "next": "Próxima Página"
  },
  "nationalDex": {
    "title": "Pokédex Nacional (1025 Pokémons)",
    "subtitle": "Mapeamento completo de todos os 1025 Pokémon existentes na franquia",
    "obtained": "Pokémons Obtidos",
    "missing": "Faltando",
    "total": "Total Mapeado",
    "completion": "Progresso Nacional",
    "filterAll": "Todos (1025)",
    "filterOwned": "Já Tenho ({count})",
    "filterMissing": "Faltando ({count})",
    "searchPlaceholder": "Buscar por nome ou número (#0025)...",
    "allGenerations": "Todas as Gerações",
    "genLabel": "Gen {gen}",
    "allTypes": "Todos os Tipos",
    "sortBy": "Ordenar",
    "sortNumberAsc": "Nº Crescente (#0001 → #1025)",
    "sortNumberDesc": "Nº Decrescente (#1025 → #0001)",
    "sortNameAsc": "Nome (A-Z)",
    "sortOwnedFirst": "Já Tenho Primeiro",
    "cardsOwnedCount": "{count} cartas",
    "copiesCount": "{count} cópias",
    "statusOwned": "Obtido",
    "statusMissing": "Não Obtido",
    "modalTitle": "Cartas de {name}",
    "modalOwnedSummary": "Você possui {cardCount} carta(s) diferente(s) deste Pokémon ({copyCount} cópias no total)",
    "modalEmptyTitle": "Nenhuma Carta Encontrada",
    "modalEmptyDesc": "Você ainda não possui nenhuma carta de {name} na sua coleção TCG.",
    "addCardForThis": "Adicionar carta de {name}",
    "viewCardDetails": "Ver detalhes da carta",
    "loadMore": "Carregar Mais Pokémons",
    "showingCount": "Exibindo {count} de {total} Pokémons",
    "totalCardsInCollection": "Cartas Pokémon no Acervo",
    "kanto": "Kanto",
    "johto": "Johto",
    "hoenn": "Hoenn",
    "sinnoh": "Sinnoh",
    "unova": "Unova",
    "kalos": "Kalos",
    "alola": "Alola",
    "galar": "Galar",
    "paldea": "Paldea",
    "deckValue": "Valor do Deck",
    "deckValuedPokemons": "{count} pokémons com valor",
    "deckSelectedCount": "{count} no deck",
    "filterDeck": "No Deck ({count})",
    "deckCard": "Carta do Deck",
    "selectForDeck": "Selecionar para o Deck",
    "removeFromDeck": "Remover do Deck",
    "chosenDeckCard": "Carta Escolhida",
    "noDeckCard": "Nenhuma carta escolhida para o deck",
    "price": "Valor",
    "updatedAt": "Atualizado em",
    "noPrice": "Sem valor"
  }
};
